import * as React from 'react'
import clx from 'classnames'
import { ChevronDownIcon } from '@/app/features/icons/ChevronDown'


type Props = {
  title: string
  isOpen: boolean
  onToggle: () => void
  isFirst?: boolean
  children: React.ReactNode
}

const TachoDiscSection = ({
  title,
  isOpen,
  onToggle,
  isFirst = false,
  children,
}: Props) => {
  return (
    <div
      className={clx(
        'first:tw-mt-0 first:tw-rounded-t-lg tw-flex tw-flex-col tw-border-b tw-border-base-300',
        isOpen && 'tw-min-h-0 tw-flex-1',
      )}
    >
      <div
        className={clx(
          'tw-flex tw-w-full tw-shrink-0 tw-items-center tw-bg-white tw-text-sm',
          isFirst && 'tw-rounded-t-lg',
        )}
      >
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={isOpen}
          className="tw-flex tw-flex-1 tw-items-center tw-justify-between tw-gap-2 tw-px-6 tw-py-2.5 tw-text-left hover:tw-brightness-95"
        >
          <span className='tw-font-semibold tw-text-content-base'>{title}</span>
          <ChevronDownIcon
            className={`tw-h-3 tw-w-3 tw-shrink-0 tw-text-content-base tw-transition-transform ${
              isOpen ? '' : '-tw-rotate-90'
            }`}
          />
        </button>
      </div>
      {isOpen && (
        <div className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-auto">
          {children}
        </div>
      )}
    </div>
  )
}

export default TachoDiscSection
